export class AdjustType {
    adjustTypcode: string
    portfolioId: number
}